var _defs, _path, _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilacom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_10",
    "data-name": "Calque 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 263 790.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:none;}.cls-2{fill:#e6eaed;}.cls-3{fill:#f7f7f7;}.cls-4{clip-path:url(#clip-path);}.cls-5{stroke:#020202;stroke-miterlimit:10;stroke-width:0.05px;}.cls-6{fill:#555452;}.cls-7{clip-path:url(#clip-path-3);}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_43);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_43-2);}.cls-10{clip-path:url(#clip-path-5);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_43-3);}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_43-4);}.cls-13{clip-path:url(#clip-path-7);}.cls-14{fill:url(#D\xE9grad\xE9_sans_nom_43-5);}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_43-6);}.cls-16{clip-path:url(#clip-path-9);}.cls-17{fill:url(#D\xE9grad\xE9_sans_nom_43-7);}.cls-18{fill:url(#D\xE9grad\xE9_sans_nom_43-8);}.cls-19{clip-path:url(#clip-path-11);}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_43-9);}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_43-10);}.cls-22{clip-path:url(#clip-path-13);}.cls-23{fill:url(#D\xE9grad\xE9_sans_nom_43-11);}.cls-24{fill:url(#D\xE9grad\xE9_sans_nom_43-12);}.cls-25{clip-path:url(#clip-path-15);}.cls-26{fill:url(#D\xE9grad\xE9_sans_nom_43-13);}.cls-27{fill:url(#D\xE9grad\xE9_sans_nom_43-14);}.cls-28{clip-path:url(#clip-path-17);}.cls-29{fill:url(#D\xE9grad\xE9_sans_nom_43-15);}.cls-30{fill:url(#D\xE9grad\xE9_sans_nom_43-16);}.cls-31{clip-path:url(#clip-path-19);}.cls-32{fill:url(#D\xE9grad\xE9_sans_nom_43-17);}.cls-33{fill:url(#D\xE9grad\xE9_sans_nom_43-18);}.cls-34{clip-path:url(#clip-path-21);}.cls-35{fill:url(#D\xE9grad\xE9_sans_nom_43-19);}.cls-36{fill:url(#D\xE9grad\xE9_sans_nom_43-20);}.cls-37{clip-path:url(#clip-path-23);}.cls-38{fill:url(#D\xE9grad\xE9_sans_nom_43-21);}.cls-39{fill:url(#D\xE9grad\xE9_sans_nom_43-22);}.cls-40{clip-path:url(#clip-path-25);}.cls-41{fill:url(#D\xE9grad\xE9_sans_nom_43-23);}.cls-42{fill:url(#D\xE9grad\xE9_sans_nom_43-24);}.cls-43{clip-path:url(#clip-path-27);}.cls-44{fill:url(#D\xE9grad\xE9_sans_nom_43-25);}.cls-45{fill:url(#D\xE9grad\xE9_sans_nom_43-26);}.cls-46{clip-path:url(#clip-path-29);}.cls-47{fill:url(#D\xE9grad\xE9_sans_nom_43-27);}.cls-48{fill:url(#D\xE9grad\xE9_sans_nom_43-28);}.cls-49{clip-path:url(#clip-path-31);}.cls-50{fill:url(#D\xE9grad\xE9_sans_nom_43-29);}.cls-51{fill:url(#D\xE9grad\xE9_sans_nom_43-30);}.cls-52{clip-path:url(#clip-path-33);}.cls-53{fill:url(#D\xE9grad\xE9_sans_nom_43-31);}.cls-54{fill:url(#D\xE9grad\xE9_sans_nom_43-32);}.cls-55{clip-path:url(#clip-path-35);}.cls-56{fill:url(#D\xE9grad\xE9_sans_nom_43-33);}.cls-57{clip-path:url(#clip-path-36);}.cls-58{fill:url(#D\xE9grad\xE9_sans_nom_41);}.cls-59{clip-path:url(#clip-path-37);}.cls-60{fill:url(#D\xE9grad\xE9_sans_nom_43-34);}.cls-61{clip-path:url(#clip-path-38);}.cls-62{fill:url(#D\xE9grad\xE9_sans_nom_40);}.cls-63{clip-path:url(#clip-path-39);}.cls-64{fill:url(#D\xE9grad\xE9_sans_nom_43-35);}.cls-65{clip-path:url(#clip-path-40);}.cls-66{fill:url(#D\xE9grad\xE9_sans_nom_40-2);}.cls-67{clip-path:url(#clip-path-41);}.cls-68{fill:url(#D\xE9grad\xE9_sans_nom_41-2);}.cls-69{clip-path:url(#clip-path-42);}.cls-70{fill:url(#D\xE9grad\xE9_sans_nom_40-3);}.cls-71{clip-path:url(#clip-path-43);}.cls-72{fill:url(#D\xE9grad\xE9_sans_nom_41-3);}.cls-73{clip-path:url(#clip-path-44);}.cls-74{fill:url(#D\xE9grad\xE9_sans_nom_43-36);}.cls-75{fill:url(#D\xE9grad\xE9_sans_nom_43-37);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1548.78 1311.55 1555.47 1777.91 1399.83 1867 1393.14 1400.64 1548.78 1311.55"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1449.53 1576.13 1448.21 1576.89 1439.9 1581.64 1438.61 1582.38 1435.38 1584.23 1434.12 1584.95 1434.14 1586.9 1434.34 1600.45 1435.6 1599.73 1435.43 1588.08 1435.4 1586.18 1436.7 1585.44 1438.63 1584.33 1439.93 1583.59 1441.19 1582.87 1448.24 1578.83 1449.56 1578.08 1449.53 1576.13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43",
    x2: 1,
    gradientTransform: "matrix(0.22, 15.5, 12.93, -7.4, 89.82, 345.54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f39f0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#f39f0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#ec641c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec641c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.23, 16.16, 13.48, -7.72, 89.82, 345.21)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1439.52,1600.43c2.14-1.22,3.88.46,3.93,3.65s-1.62,6.77-3.77,8-3.91-.35-4-3.58,1.67-6.86,3.79-8.07m5.33,8.69-1.76,1a15,15,0,0,0,1.68-6.81c-.06-4.3-2.46-6.41-5.28-4.79s-5.09,6.39-5,10.69c0,2.3.71,4,1.79,4.83l-1.7,1,0,2,10.31-5.9Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.22, 15.54, 12.97, -7.42, 87.5, 363.52)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.23, 16.2, 13.52, -7.74, 1439.5, 1598.19)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1443.24,1624.86l1.79-1,0-1.95-5.17,3-5.11,2.92,0,2,1.73-1,3.38-1.94c2.14-1.22,3.88.42,3.93,3.61l1.32-.76c0-2.3-.77-4-1.88-4.78"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.11, 7.75, 6.47, -3.7, 87.87, 389.83)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.12, 8.41, 7.02, -4.02, 1439.86, 1624.5)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1439.4,1635.94c.21-.11.41-.32.62-.44s.44-.16.65-.28a1.9,1.9,0,0,1,1.6.11,2.15,2.15,0,0,1,.93.85,5.17,5.17,0,0,1,.78,3,10.15,10.15,0,0,1-.69,3.74l-2.25-2.06-.3-.28-.66-.6-.63-.58-1.62-1.48a7.17,7.17,0,0,1,1.57-1.93m4.72-1.71c-.12-.2-.3-.32-.43-.52a4.29,4.29,0,0,1-.5-.33,2.64,2.64,0,0,0-2.55-.06,1.71,1.71,0,0,0-.65.28,2.59,2.59,0,0,0-.61.44,8.87,8.87,0,0,0-2.51,3c-.17.32-.31.63-.49.91s-.25.63-.4,1a14.83,14.83,0,0,0-1,5.41,7.07,7.07,0,0,0,1.15,4.11,5,5,0,0,1,.42.52,3.77,3.77,0,0,1,.51.34l.92-1.91a3.07,3.07,0,0,1-1-.88,5.4,5.4,0,0,1-.75-2.92,10.87,10.87,0,0,1,.65-3.77l2.28,2.09.3.23.63.62.66.56,1.62,1.53,1,.83c.18-.32.32-.62.49-.9s.29-.66.4-1a14.44,14.44,0,0,0,1-5.35,7.19,7.19,0,0,0-1.12-4.17"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-7",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.2, 13.86, 11.57, -6.62, 87.99, 398.6)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-8",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.21, 14.69, 12.26, -7.02, 1439.99, 1633.27)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1435.08 1652.35 1435.11 1654.3 1455.72 1642.5 1455.69 1640.55 1435.08 1652.35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-9",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.03, 1.95, 1.63, -0.93, 93.39, 411.45)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-10",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.04, 2.61, 2.18, -1.25, 93.38, 411.12)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1440.29,1654.32c2.14-1.23,3.88.45,3.93,3.64s-1.62,6.78-3.76,8-3.92-.35-4-3.59,1.68-6.85,3.79-8.06m5.33,8.69-1.76,1a15.07,15.07,0,0,0,1.68-6.81c-.06-4.3-2.46-6.41-5.28-4.8s-5.09,6.4-5,10.7c0,2.3.7,4,1.78,4.82l-1.7,1,0,2,10.3-5.9Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-11",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.22, 15.54, 12.97, -7.42, 88.28, 417.41)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-12",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.23, 16.2, 13.52, -7.74, 1440.27, 1652.08)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1450.86 1666.88 1445.69 1669.84 1445.65 1666.96 1444.33 1667.72 1444.37 1670.6 1435.42 1675.72 1435.44 1677.67 1444.4 1672.55 1444.44 1675.43 1445.76 1674.67 1445.72 1671.79 1450.89 1668.83 1450.86 1666.88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-13",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.11, 7.71, 6.43, -3.68, 91.1, 433.43)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-14",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.12, 8.36, 6.98, -3.99, 91.09, 433.1)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1435.51,1682.54l0,2,10.31-5.9,0-2Zm12.54-7.17a1.65,1.65,0,0,0-.63,1.34c0,.58.31.85.66.65a1.68,1.68,0,0,0,.66-1.41c0-.53-.31-.8-.69-.58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-15",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.03, 1.99, 1.66, -0.95, 90.12, 443.76)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-16",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.04, 2.65, 2.21, -1.27, 1442.12, 1678.43)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1440.7,1684.62c2.14-1.22,3.88.41,3.92,3.6.05,3.37-1.61,6.87-3.76,8.09s-3.85-.34-3.9-3.7c0-3.19,1.62-6.78,3.74-8m0-1.95c-2.79,1.6-5.06,6.47-5,10.68s2.43,6.51,5.22,4.91,5.12-6.5,5.06-10.79-2.43-6.43-5.28-4.8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-17",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.22, 15.59, 13.01, -7.45, 88.7, 447.66)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-18",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.23, 16.25, 13.56, -7.76, 1440.69, 1682.33)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1444.37,1699.13l1.76-1,0-1.9-5.17,3-5.14,2.95,0,1.9,1.71-1,3.43-2c2.14-1.23,3.88.45,3.93,3.69s-1.62,6.73-3.76,8l-3.44,2-1.7,1,0,2,5.14-2.94a9.29,9.29,0,0,0,3.37-4,14.71,14.71,0,0,0,1.68-6.76,6.27,6.27,0,0,0-1.84-4.88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-19",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.22, 15.54, 12.97, -7.42, 88.95, 464.17)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-20",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.23, 16.2, 13.52, -7.74, 1440.94, 1698.84)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1445.39,1725.24a1.58,1.58,0,0,0-.42-.48,2.07,2.07,0,0,0-.48-.43,3.19,3.19,0,0,0-3.19.22,9.13,9.13,0,0,0-3.12,3.39,3.52,3.52,0,0,0-.46,1,4,4,0,0,0-.46,1,14.88,14.88,0,0,0-1,5.35,7.47,7.47,0,0,0,1.13,4.17,2,2,0,0,0,.48.44,1.34,1.34,0,0,0,.47.36l.9-1.85a2.5,2.5,0,0,1-.93-.9,5.47,5.47,0,0,1-.79-2.94,10.78,10.78,0,0,1,.69-3.79,9,9,0,0,1,.89-1.9,6.82,6.82,0,0,1,2.21-2.38,2.48,2.48,0,0,1,2.28-.19,2.77,2.77,0,0,1,.93.86,5.48,5.48,0,0,1,.72,3,11,11,0,0,1-.62,3.76,17.26,17.26,0,0,1-.89,1.93l.93.81c.14-.26.31-.63.46-.89s.28-.65.4-.94a14.59,14.59,0,0,0,1-5.42,6.69,6.69,0,0,0-1.19-4.1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-21",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.2, 13.86, 11.57, -6.62, 89.31, 489.54)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-22",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.21, 14.68, 12.25, -7.01, 1441.31, 1724.21)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1436.38 1743.3 1436.41 1745.24 1457.03 1733.45 1457 1731.5 1436.38 1743.3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-23",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.03, 1.95, 1.63, -0.93, 94.69, 502.4)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-24",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.04, 2.61, 2.17, -1.24, 94.69, 502.07)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1436.44,1747.24l0,2,10.31-5.9,0-2Zm12.54-7.18a1.65,1.65,0,0,0-.63,1.34c0,.58.31.86.66.65a1.66,1.66,0,0,0,.66-1.4c0-.53-.31-.81-.69-.59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-25",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.03, 1.99, 1.66, -0.95, 91.05, 508.46)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-26",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.04, 2.65, 2.21, -1.27, 1443.04, 1743.13)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1441,1749.65c.2-.12.41-.32.61-.44s.44-.16.65-.28a1.9,1.9,0,0,1,1.6.11,2.09,2.09,0,0,1,.93.85,5.17,5.17,0,0,1,.78,2.95,10.15,10.15,0,0,1-.69,3.74l-2.25-2.06-.3-.28-.66-.6-.63-.58-1.62-1.48a6.87,6.87,0,0,1,1.58-1.93m4.71-1.71c-.12-.2-.3-.32-.42-.52a3.67,3.67,0,0,1-.51-.33,2.64,2.64,0,0,0-2.55-.06,1.71,1.71,0,0,0-.65.28,2.33,2.33,0,0,0-.61.44,8.64,8.64,0,0,0-2.5,3c-.18.32-.32.63-.5.91s-.25.63-.4,1a14.83,14.83,0,0,0-1,5.41,7.07,7.07,0,0,0,1.15,4.11,5,5,0,0,1,.42.52,3,3,0,0,1,.51.34l.92-1.91a3.07,3.07,0,0,1-1-.88,5.49,5.49,0,0,1-.75-2.92,10.65,10.65,0,0,1,.66-3.77l2.27,2.09.3.23.63.62.66.56,1.62,1.53,1,.83c.18-.32.32-.62.49-.9s.29-.66.4-1a14.43,14.43,0,0,0,1-5.34,7.21,7.21,0,0,0-1.12-4.18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-27",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.2, 13.86, 11.57, -6.62, 89.62, 512.31)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-28",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.21, 14.69, 12.26, -7.02, 1441.62, 1746.98)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1445.28,1763.07l1.77-1,0-1.9-5.17,2.95-5.14,3,0,1.9,1.7-1,3.44-2c2.14-1.23,3.88.45,3.93,3.69s-1.62,6.73-3.77,8l-3.43,2-1.7,1,0,2,5.14-2.94a9.33,9.33,0,0,0,3.38-3.94,14.9,14.9,0,0,0,1.68-6.77c0-2.35-.77-4-1.85-4.88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-29",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.22, 15.54, 12.97, -7.42, 89.87, 528.11)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-30",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.23, 16.2, 13.52, -7.74, 1441.86, 1762.78)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1452.45 1777.59 1447.28 1780.54 1447.24 1777.66 1445.92 1778.42 1445.96 1781.3 1437 1786.43 1437.03 1788.38 1445.99 1783.25 1446.03 1786.13 1447.35 1785.37 1447.31 1782.49 1452.48 1779.53 1452.45 1777.59"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-31",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.11, 7.71, 6.43, -3.68, 92.69, 544.13)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-32",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.12, 8.36, 6.98, -3.99, 92.68, 543.8)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1510.06,1371.6l-.06-4.35c0-3-2.14-4.3-4.66-2.86l-4.16,2.39a10.09,10.09,0,0,0-4.5,8.1l.07,4.35c0,3,2.14,4.3,4.65,2.86l4.17-2.38a10.09,10.09,0,0,0,4.49-8.1h0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-33",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.22, 15.32, 12.78, -7.32, 151.26, 130.58)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1510.23,1382.78c0-3-2.14-4.31-4.66-2.87l-4.16,2.39a10.09,10.09,0,0,0-4.5,8.1l.06,4.35c0,3,2.14,4.31,4.66,2.87l4.16-2.39a10.09,10.09,0,0,0,4.5-8.1Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_41",
    x2: 1,
    gradientTransform: "matrix(0.22, 15.32, 12.78, -7.31, 151.49, 146.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#54a333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#54a333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#c8d400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c8d400"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1510.52,1402.65l-.07-4.35c0-3-2.14-4.3-4.65-2.86l-4.17,2.38a10.09,10.09,0,0,0-4.49,8.11l.06,4.35c0,3,2.14,4.3,4.66,2.86l4.16-2.39a10.09,10.09,0,0,0,4.5-8.1h0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-34",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.22, 15.32, 12.78, -7.32, 151.72, 161.63)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1496.5,1375c0-3-2.13-4.3-4.65-2.86l-4.16,2.38a10.1,10.1,0,0,0-4.5,8.11l.06,4.35c0,3,2.14,4.3,4.66,2.86l4.16-2.38a10.1,10.1,0,0,0,4.5-8.1Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_40",
    x2: 1,
    gradientTransform: "matrix(0.22, 15.32, 12.78, -7.31, 137.77, 138.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c9ad6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2c9ad6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#81ccd7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81ccd7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1496.79,1394.86l-.06-4.35c0-3-2.14-4.31-4.66-2.87l-4.16,2.39a10.1,10.1,0,0,0-4.5,8.1l.07,4.35c0,3,2.14,4.31,4.65,2.87l4.17-2.39a10.09,10.09,0,0,0,4.49-8.1h0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-35",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.22, 15.32, 12.78, -7.32, 137.99, 153.83)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1497,1406c0-3-2.14-4.3-4.66-2.86l-4.16,2.38a10.1,10.1,0,0,0-4.5,8.1l.06,4.36c0,3,2.14,4.3,4.66,2.86l4.16-2.38a10.1,10.1,0,0,0,4.5-8.11Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_40-2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.22, 15.32, 12.78, -7.31, 138.22, 169.36)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_40"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1483.07,1387.06l-.06-4.35c0-3-2.14-4.3-4.66-2.86l-4.16,2.39a10.09,10.09,0,0,0-4.5,8.1l.07,4.35c0,3,2.13,4.3,4.65,2.86l4.17-2.38a10.09,10.09,0,0,0,4.49-8.11h0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_41-2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.22, 15.32, 12.78, -7.32, 124.27, 146.04)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_41"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1483.24,1398.24c0-3-2.14-4.31-4.66-2.87l-4.16,2.39a10.09,10.09,0,0,0-4.5,8.1l.06,4.35c0,3,2.14,4.31,4.66,2.87l4.16-2.39a10.09,10.09,0,0,0,4.5-8.1Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_40-3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.22, 15.32, 12.78, -7.31, 124.5, 161.56)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_40"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1483.52,1418.11l-.06-4.35c0-3-2.14-4.3-4.65-2.86l-4.17,2.38a10.1,10.1,0,0,0-4.5,8.11l.07,4.35c0,3,2.14,4.3,4.65,2.86l4.17-2.39a10.08,10.08,0,0,0,4.49-8.1h0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_41-3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.22, 15.32, 12.78, -7.32, 124.72, 177.09)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_41"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44",
    transform: "translate(-1352 -1235)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1468.93,1517a16.75,16.75,0,0,1,5.86-6l1.54-.88c2.87-1.21,5.29-1.19,7.24.07,2.15,1.42,3.26,4.21,3.32,8.39a18.12,18.12,0,0,1-2.65,9.7,16.77,16.77,0,0,1-6.12,6.17q-4.5,2.6-8,.68t-3.59-8.77v-.56a16.14,16.14,0,0,1,2.4-8.79m24.45-26.39q-6.84-4.21-16.44,1.28-9.39,5.37-15.9,17.15a55.29,55.29,0,0,0-7,28,36.56,36.56,0,0,0,1.91,11.75c1.22,3.41,2.51,5.41,3.89,6l1.42-1.94c-1.39-.76-2.63-2.79-3.74-6.07a34.56,34.56,0,0,1-1.75-10.59,51.24,51.24,0,0,1,6.42-25.89q6-10.93,14.79-15.95t15.2-1.22q7,4.3,7.15,18.12a51.14,51.14,0,0,1-3.62,19.87,51.67,51.67,0,0,1-12.9,18.73,27.34,27.34,0,0,1-3.26,2.19,13.42,13.42,0,0,1-8.3,2.1q-4.32-.51-4.4-5.45a6.53,6.53,0,0,1,2.09-5.3c1.56-1.11,3.15-2.21,4.79-3.31l14.72-6.09,0-2.32-4.92,1.69a17.44,17.44,0,0,0,3.17-5.44,25.69,25.69,0,0,0,2.16-10.41q-.11-7.66-4.69-10c-2.78-1.47-5.9-1.2-9.39.79a20,20,0,0,0-7.22,7.6,21.81,21.81,0,0,0-2.93,11.58q.14,9.81,5.3,11a7.37,7.37,0,0,0,2.26,0l-.72.17a13.58,13.58,0,0,0-4,3.48,11,11,0,0,0-2.57,7.26c.06,4.48,1.75,7,5,7.5q3.93.58,9.43-2.58c.41-.23,1.07-.66,2-1.29l1.88-1.32a51.46,51.46,0,0,0,14.41-21.21,55.83,55.83,0,0,0,3.61-20.35q-.21-14.85-7.89-19.55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-36",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.91, 63.32, 52.84, -30.25, 125.2, 256.75)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_43-37",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientTransform: "matrix(0.92, 63.98, 53.39, -30.56, 1477.19, 1491.43)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_43"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "filacom") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1615,2013V1235l-263,149,5,519,227-134,1-492,10-7.8V2020C1595,2027,1615,2030,1615,2013Z",
    transform: "translate(-1352 -1235)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "233 42 0.22 172 5 668 232 534 233 42"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 110.27,
    y1: 137.3,
    x2: 111.3,
    y2: 208.64
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1517.34,1426.23l.3,20.81a7.16,7.16,0,0,1-3.13,5.77l0,0-.31-21.56c-.09-6.21-4.26-9-9.26-6.1l-13.27,7.73.84,24.45c-1.74,1-3.27,3.58-3.3,1.42l-.55-14.34c.16-9.35-2.59-8.45-5.94-6.54L1463.37,1449l-.07-5.09,43.25-24.76c5.85-3.35,10.69-.16,10.79,7.12",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1517.34,1426.23l.3,20.81a7.16,7.16,0,0,1-3.13,5.77l0,0-.31-21.56c-.09-6.21-4.26-9-9.26-6.1l-13.27,7.73.84,24.45c-1.74,1-3.27,3.58-3.3,1.42l-.55-14.34c.16-9.35-2.59-8.45-5.94-6.54L1463.37,1449l-.07-5.09,43.25-24.76C1512.4,1415.76,1517.24,1419,1517.34,1426.23Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1493.37,1462.72l.08,5.38-29.37,16.81-.08-5.38Zm11.26-4.17a10.81,10.81,0,0,1-1.1,5,7.06,7.06,0,0,1-2.79,3.17,2.36,2.36,0,0,1-2.69,0c-.88-.6-1.34-1.73-1.36-3.4a9.85,9.85,0,0,1,1.1-4.87,7.61,7.61,0,0,1,2.79-3.08,2.69,2.69,0,0,1,2.83-.24c.79.46,1.2,1.6,1.22,3.42",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1493.37,1462.72l.08,5.38-29.37,16.81-.08-5.38Zm11.26-4.17a10.81,10.81,0,0,1-1.1,5,7.06,7.06,0,0,1-2.79,3.17,2.36,2.36,0,0,1-2.69,0c-.88-.6-1.34-1.73-1.36-3.4a9.85,9.85,0,0,1,1.1-4.87,7.61,7.61,0,0,1,2.79-3.08,2.69,2.69,0,0,1,2.83-.24C1504.2,1455.59,1504.61,1456.73,1504.63,1458.55Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "158.26 228.63 158.34 233.59 111.8 260.23 111.73 255.26 158.26 228.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "158.26 228.63 158.34 233.59 111.8 260.23 111.73 255.26 158.26 228.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1489.2,1595.4a33.52,33.52,0,0,0,1.94-4.7,41.77,41.77,0,0,0,1.83-13.14v-.33q-.14-9.51-4.11-13c-2.42-2.07-5.29-2.14-8.62-.24s-6.06,5.25-8.38,10.14a39.05,39.05,0,0,0-3.76,17.66q.11,6.87,2.21,10.67a9.08,9.08,0,0,0,2.18,2.5l-4.5,2.58a11,11,0,0,1-1.41-2.86,37.19,37.19,0,0,1-1.53-11.14,50.32,50.32,0,0,1,4.54-22.45q4.31-9.13,10.57-12.73t10.85.38q5.1,4.51,5.28,16.92A53.3,53.3,0,0,1,1495,1588a40,40,0,0,1-1.36,4.88Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1489.2,1595.4a33.52,33.52,0,0,0,1.94-4.7,41.77,41.77,0,0,0,1.83-13.14v-.33q-.14-9.51-4.11-13c-2.42-2.07-5.29-2.14-8.62-.24s-6.06,5.25-8.38,10.14a39.05,39.05,0,0,0-3.76,17.66q.11,6.87,2.21,10.67a9.08,9.08,0,0,0,2.18,2.5l-4.5,2.58a11,11,0,0,1-1.41-2.86,37.19,37.19,0,0,1-1.53-11.14,50.32,50.32,0,0,1,4.54-22.45q4.31-9.13,10.57-12.73t10.85.38q5.1,4.51,5.28,16.92A53.3,53.3,0,0,1,1495,1588a40,40,0,0,1-1.36,4.88Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1496.88,1617.53a42.44,42.44,0,0,1-4.66,20.42q-4.41,8.46-10.75,12.09t-10.84.34q-4.83-3.69-5-15a42.36,42.36,0,0,1,4.57-20.29q4.32-8.42,10.58-12t10.84-.34q5.08,3.7,5.25,14.74m-3.31,1.9q-.13-8.61-4.09-11.54-3.63-2.61-8.61.25t-8.4,9.41a33.12,33.12,0,0,0-3.78,16.12q.13,8.76,4,11.59,3.52,2.58,8.69-.37a22.37,22.37,0,0,0,8.48-9.39,33.11,33.11,0,0,0,3.7-16.07",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1496.88,1617.53a42.44,42.44,0,0,1-4.66,20.42q-4.41,8.46-10.75,12.09t-10.84.34q-4.83-3.69-5-15a42.36,42.36,0,0,1,4.57-20.29q4.32-8.42,10.58-12t10.84-.34Q1496.72,1606.5,1496.88,1617.53Zm-3.31,1.9q-.13-8.61-4.09-11.54-3.63-2.61-8.61.25t-8.4,9.41a33.12,33.12,0,0,0-3.78,16.12q.13,8.76,4,11.59,3.52,2.58,8.69-.37a22.37,22.37,0,0,0,8.48-9.39A33.11,33.11,0,0,0,1493.57,1619.43Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1466.71,1668.17l-.08-5,30.31-17.34.07,5-3.65,2.09a3.37,3.37,0,0,1,2.94,1.74c.93,1.69,1.43,4.4,1.48,8.16a32.27,32.27,0,0,1-2.46,13.33,24,24,0,0,1-2.59,4.49,4.52,4.52,0,0,1,1.72.6q3.88,2.44,4,11.13.13,9.11-2.23,14.33a19,19,0,0,1-8.22,8.59L1467.55,1727l-.08-5.21,20.46-11.71a13.14,13.14,0,0,0,5.74-5.87q1.57-3.5,1.48-9.94-.18-12.49-7.56-8.27l-20.46,11.71-.08-5.21,20.46-11.71a13,13,0,0,0,5.52-6.1,24.13,24.13,0,0,0,1.7-10.21c-.06-4-.81-6.63-2.26-7.9s-3.21-1.31-5.31-.11Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1466.71,1668.17l-.08-5,30.31-17.34.07,5-3.65,2.09a3.37,3.37,0,0,1,2.94,1.74c.93,1.69,1.43,4.4,1.48,8.16a32.27,32.27,0,0,1-2.46,13.33,24,24,0,0,1-2.59,4.49,4.52,4.52,0,0,1,1.72.6q3.88,2.44,4,11.13.13,9.11-2.23,14.33a19,19,0,0,1-8.22,8.59L1467.55,1727l-.08-5.21,20.46-11.71a13.14,13.14,0,0,0,5.74-5.87q1.57-3.5,1.48-9.94-.18-12.49-7.56-8.27l-20.46,11.71-.08-5.21,20.46-11.71a13,13,0,0,0,5.52-6.1,24.13,24.13,0,0,0,1.7-10.21c-.06-4-.81-6.63-2.26-7.9s-3.21-1.31-5.31-.11Z",
    transform: "translate(-1352 -1235)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "97.53 341.13 97.75 356.63 82.34 365.45 82.11 349.95 97.53 341.13"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "83.43 353.08 83.43 353.08 83.6 364.73 82.34 365.45 82.14 351.9 82.11 349.95 83.38 349.23 86.61 347.38 87.9 346.64 96.21 341.89 97.53 341.13 97.56 343.08 96.24 343.83 89.19 347.87 87.93 348.59 86.64 349.33 84.7 350.44 83.41 351.18 83.43 353.08 83.43 353.08 83.43 353.08 83.41 351.18 84.7 350.44 86.64 349.33 87.93 348.59 89.19 347.87 96.24 343.83 97.56 343.08 97.53 341.13 96.21 341.89 87.9 346.64 86.61 347.38 83.38 349.23 82.11 349.95 82.14 351.9 82.34 365.45 83.6 364.73 83.43 353.08 83.43 353.08"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "92.66 360.57 92.88 376.11 82.57 382.01 82.35 366.47 92.66 360.57"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1444.85,1609.12h0l0,2-10.31,5.9,0-2,1.7-1c-1.08-.82-1.75-2.53-1.79-4.83-.06-4.3,2.18-9.06,5-10.69s5.22.49,5.28,4.79a15,15,0,0,1-1.68,6.81l1.76-1h0l-1.76,1a15,15,0,0,0,1.68-6.81c-.06-4.3-2.46-6.41-5.28-4.79s-5.09,6.39-5,10.69c0,2.3.71,4,1.79,4.83l-1.7,1,0,2,10.31-5.9,0-2Zm-5.17,3h0c2.15-1.23,3.81-4.77,3.77-8s-1.79-4.87-3.93-3.65-3.84,4.88-3.8,8.07,1.85,4.79,4,3.58h0c-2.11,1.21-3.91-.35-4-3.58s1.68-6.86,3.8-8.07,3.88.46,3.93,3.65-1.62,6.77-3.77,8Z",
    transform: "translate(-1352 -1235)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "93.01 386.89 93.12 394.64 82.84 400.52 82.73 392.77 93.01 386.89"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1445.12,1629.64h0l-1.32.76c0-3.19-1.79-4.83-3.93-3.6l-3.38,1.93-1.73,1,0-2,5.11-2.92,5.17-3,0,1.95-1.79,1c1.11.75,1.84,2.48,1.88,4.78h0c0-2.3-.77-4-1.88-4.78l1.79-1,0-1.95-5.17,3-5.11,2.92,0,2,1.73-1,3.38-1.93c2.14-1.23,3.88.41,3.93,3.6l1.32-.76Z",
    transform: "translate(-1352 -1235)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "93.13 395.66 93.33 409.52 83.05 415.4 82.85 401.54 93.13 395.66"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1438,1647.34h0l-.92,1.92a3.77,3.77,0,0,0-.51-.34,5,5,0,0,0-.42-.52,7.07,7.07,0,0,1-1.15-4.11,14.83,14.83,0,0,1,1-5.41c.15-.35.29-.65.4-1s.32-.59.49-.91a8.87,8.87,0,0,1,2.51-3,2.33,2.33,0,0,1,.61-.44,1.71,1.71,0,0,1,.65-.28,2.64,2.64,0,0,1,2.55.06,4.29,4.29,0,0,0,.5.33c.13.2.31.32.43.52a7.21,7.21,0,0,1,1.12,4.18,14.39,14.39,0,0,1-1,5.34c-.11.33-.28.65-.4,1s-.31.58-.49.9l-1-.83-1.62-1.53-.66-.56-.63-.62-.3-.23-2.28-2.09a10.87,10.87,0,0,0-.65,3.77,5.4,5.4,0,0,0,.75,2.92,2.92,2.92,0,0,0,1,.87h0a2.92,2.92,0,0,1-1-.87,5.4,5.4,0,0,1-.75-2.92,10.87,10.87,0,0,1,.65-3.77l2.28,2.09.3.23.63.62.66.56,1.62,1.53,1,.83c.18-.32.32-.63.49-.9s.29-.66.4-1a14.39,14.39,0,0,0,1-5.34,7.21,7.21,0,0,0-1.12-4.18c-.12-.2-.3-.32-.43-.52a4.29,4.29,0,0,1-.5-.33,2.64,2.64,0,0,0-2.55-.06,1.71,1.71,0,0,0-.65.28,2.33,2.33,0,0,0-.61.44,8.87,8.87,0,0,0-2.51,3c-.17.32-.31.63-.49.91s-.25.63-.4,1a14.83,14.83,0,0,0-1,5.41,7.07,7.07,0,0,0,1.15,4.11,5,5,0,0,1,.42.52,3.77,3.77,0,0,1,.51.34l.92-1.92Zm-.14-9.47h0l1.62,1.48.63.58.66.6.3.28,2.25,2.06a10.15,10.15,0,0,0,.69-3.74,5.17,5.17,0,0,0-.78-3,2.15,2.15,0,0,0-.93-.85,1.9,1.9,0,0,0-1.6-.11c-.21.12-.42.15-.65.28s-.41.33-.62.44a7.17,7.17,0,0,0-1.57,1.93h0a7.17,7.17,0,0,1,1.57-1.93c.21-.11.41-.32.62-.44s.44-.16.65-.28a1.9,1.9,0,0,1,1.6.11,2.15,2.15,0,0,1,.93.85,5.17,5.17,0,0,1,.78,3,10.15,10.15,0,0,1-.69,3.74l-2.25-2.06-.3-.28-.66-.6-.63-.58-1.62-1.48Z",
    transform: "translate(-1352 -1235)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "103.69 405.55 103.72 407.5 83.11 419.3 83.08 417.35 103.69 405.55"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "103.69 405.55 103.69 405.55 103.72 407.5 83.11 419.3 83.08 417.35 103.69 405.55 103.69 405.55 103.69 405.55 83.08 417.35 83.11 419.3 103.72 407.5 103.69 405.55 103.69 405.55"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "93.43 414.46 93.65 430 83.35 435.9 83.12 420.36 93.43 414.46"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1445.62,1663h0l0,2-10.3,5.9,0-2,1.7-1c-1.08-.81-1.75-2.52-1.78-4.82-.07-4.3,2.17-9.07,5-10.7s5.22.5,5.28,4.8a15.07,15.07,0,0,1-1.68,6.81l1.76-1h0l-1.76,1a15.07,15.07,0,0,0,1.68-6.81c-.06-4.3-2.46-6.41-5.28-4.8s-5.09,6.4-5,10.7c0,2.3.7,4,1.78,4.82l-1.7,1,0,2,10.3-5.9,0-2Zm-5.16,3h0c2.14-1.23,3.81-4.77,3.76-8s-1.79-4.87-3.93-3.64-3.84,4.87-3.79,8.06,1.84,4.8,4,3.59h0c-2.12,1.21-3.92-.35-4-3.59s1.68-6.85,3.79-8.06,3.88.45,3.93,3.64-1.62,6.78-3.76,8Z",
    transform: "translate(-1352 -1235)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "98.82 429.01 98.93 436.71 83.49 445.55 83.38 437.85 98.82 429.01"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "93.72 436.79 93.72 436.79 93.76 439.67 92.44 440.43 92.4 437.55 83.44 442.67 83.42 440.73 92.37 435.6 92.33 432.72 93.65 431.96 93.69 434.84 98.86 431.88 98.89 433.83 93.72 436.79 93.72 436.79 93.72 436.79 98.89 433.83 98.86 431.88 93.69 434.84 93.65 431.96 92.33 432.72 92.37 435.6 83.42 440.73 83.44 442.67 92.4 437.55 92.44 440.43 93.76 439.67 93.72 436.79 93.72 436.79"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "96.73 439.98 96.75 441.97 83.54 449.54 83.51 447.54 96.73 439.98"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1448.05,1675.37h0c.38-.22.68.05.69.58a1.68,1.68,0,0,1-.66,1.41c-.35.2-.65-.07-.66-.65a1.65,1.65,0,0,1,.63-1.34h0a1.65,1.65,0,0,0-.63,1.34c0,.58.31.85.66.65a1.68,1.68,0,0,0,.66-1.41c0-.53-.31-.8-.69-.58Zm-12.51,9.17h0l0-2,10.31-5.9,0,2-10.31,5.9h0l10.31-5.9,0-2-10.31,5.9,0,2Z",
    transform: "translate(-1352 -1235)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "93.83 444.71 94.06 460.3 83.78 466.19 83.56 450.6 93.83 444.71"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1440.89,1698.26h0c-2.79,1.6-5.16-.62-5.22-4.91s2.21-9.08,5-10.68,5.22.59,5.28,4.8-2.21,9.16-5.06,10.79h0c2.85-1.63,5.12-6.5,5.06-10.79s-2.43-6.43-5.28-4.8-5.06,6.47-5,10.68,2.43,6.51,5.22,4.91Zm0-2h0c2.15-1.22,3.81-4.72,3.76-8.09,0-3.19-1.78-4.82-3.92-3.6s-3.79,4.8-3.74,8c0,3.36,1.79,4.91,3.9,3.7h0c-2.11,1.21-3.85-.34-3.9-3.7,0-3.19,1.62-6.78,3.74-8s3.88.41,3.92,3.6c.05,3.37-1.61,6.87-3.76,8.09Z",
    transform: "translate(-1352 -1235)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "94.1 461.22 94.32 476.76 84.02 482.66 83.8 467.12 94.1 461.22"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1444.53,1710.77h0a9.29,9.29,0,0,1-3.37,4l-5.14,2.94,0-2,1.7-1,3.44-2c2.14-1.22,3.81-4.77,3.76-8s-1.79-4.92-3.93-3.69l-3.43,2-1.71,1,0-1.9,5.14-2.95,5.17-3,0,1.9-1.76,1a6.27,6.27,0,0,1,1.84,4.88,14.71,14.71,0,0,1-1.68,6.76h0a14.71,14.71,0,0,0,1.68-6.76,6.27,6.27,0,0,0-1.84-4.88l1.76-1,0-1.9-5.17,3-5.14,2.95,0,1.9,1.71-1,3.43-2c2.14-1.23,3.88.45,3.93,3.69s-1.62,6.73-3.76,8l-3.44,2-1.7,1,0,2,5.14-2.94a9.29,9.29,0,0,0,3.37-4Z",
    transform: "translate(-1352 -1235)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "94.47 486.59 94.66 500.45 84.36 506.35 84.16 492.49 94.47 486.59"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1443.6,1726.26h0a2.48,2.48,0,0,0-2.28.19,6.82,6.82,0,0,0-2.21,2.38,9,9,0,0,0-.89,1.9,10.78,10.78,0,0,0-.69,3.79,5.47,5.47,0,0,0,.79,2.94,2.5,2.5,0,0,0,.93.9l-.9,1.85a1.34,1.34,0,0,1-.47-.36,2,2,0,0,1-.48-.44,7.45,7.45,0,0,1-1.13-4.17,14.88,14.88,0,0,1,1-5.35,4,4,0,0,1,.46-1,3.52,3.52,0,0,1,.46-1,9.13,9.13,0,0,1,3.12-3.39,3.19,3.19,0,0,1,3.19-.22,2.07,2.07,0,0,1,.48.43,1.58,1.58,0,0,1,.42.48,6.69,6.69,0,0,1,1.19,4.1,14.59,14.59,0,0,1-1,5.42c-.12.29-.29.65-.4.94s-.32.63-.46.89l-.93-.81a17.26,17.26,0,0,0,.89-1.93,11,11,0,0,0,.62-3.75,5.49,5.49,0,0,0-.72-3,2.77,2.77,0,0,0-.93-.86h0a2.77,2.77,0,0,1,.93.86,5.49,5.49,0,0,1,.72,3,11,11,0,0,1-.62,3.75,17.26,17.26,0,0,1-.89,1.93l.93.81c.14-.26.31-.63.46-.89s.28-.65.4-.94a14.59,14.59,0,0,0,1-5.42,6.69,6.69,0,0,0-1.19-4.1,1.58,1.58,0,0,0-.42-.48,2.07,2.07,0,0,0-.48-.43,3.19,3.19,0,0,0-3.19.22,9.13,9.13,0,0,0-3.12,3.39,3.52,3.52,0,0,0-.46,1,4,4,0,0,0-.46,1,14.88,14.88,0,0,0-1,5.35,7.45,7.45,0,0,0,1.13,4.17,2,2,0,0,0,.48.44,1.34,1.34,0,0,0,.47.36l.9-1.85a2.5,2.5,0,0,1-.93-.9,5.47,5.47,0,0,1-.79-2.94,10.78,10.78,0,0,1,.69-3.79,9,9,0,0,1,.89-1.9,6.82,6.82,0,0,1,2.21-2.38,2.48,2.48,0,0,1,2.28-.19Z",
    transform: "translate(-1352 -1235)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "105 496.5 105.03 498.45 84.41 510.24 84.39 508.3 105 496.5"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "105 496.5 105 496.5 105.03 498.44 84.41 510.24 84.39 508.3 105 496.5 105 496.5 105 496.5 84.39 508.3 84.41 510.24 105.03 498.44 105 496.5 105 496.5"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "97.66 504.67 97.68 506.67 84.47 514.23 84.44 512.24 97.66 504.67"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M1449,1740.06h0c.38-.22.68.06.69.59a1.68,1.68,0,0,1-.66,1.4c-.35.2-.65-.07-.66-.65a1.65,1.65,0,0,1,.63-1.34h0a1.65,1.65,0,0,0-.63,1.34c0,.58.31.85.66.65a1.68,1.68,0,0,0,.66-1.4c0-.53-.31-.81-.69-.59Zm-12.51,9.17h0l0-2,10.31-5.9,0,2-10.31,5.9h0l10.31-5.9,0-2-10.31,5.9,0,2Z",
    transform: "translate(-1352 -1235)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "94.76 509.37 94.96 523.23 84.68 529.11 84.48 515.25 94.76 509.37"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M1439.6,1761.05h0l-.92,1.92a3,3,0,0,0-.51-.34,5,5,0,0,0-.42-.52,7.07,7.07,0,0,1-1.15-4.11,14.83,14.83,0,0,1,1-5.41c.15-.35.29-.65.4-1s.32-.59.5-.91a8.64,8.64,0,0,1,2.5-3,2.33,2.33,0,0,1,.61-.44,1.71,1.71,0,0,1,.65-.28,2.64,2.64,0,0,1,2.55.06,3.67,3.67,0,0,0,.51.33c.12.2.3.32.42.52a7.21,7.21,0,0,1,1.12,4.18,14.43,14.43,0,0,1-1,5.34c-.11.33-.28.65-.4,1s-.31.58-.49.9l-1-.83-1.62-1.53-.66-.56-.63-.62-.3-.23-2.27-2.09a10.65,10.65,0,0,0-.66,3.77,5.49,5.49,0,0,0,.75,2.92,2.92,2.92,0,0,0,1,.87h0a2.92,2.92,0,0,1-1-.87,5.49,5.49,0,0,1-.75-2.92,10.65,10.65,0,0,1,.66-3.77l2.27,2.09.3.23.63.62.66.56,1.62,1.53,1,.83c.18-.32.32-.63.49-.9s.29-.66.4-1a14.43,14.43,0,0,0,1-5.34,7.21,7.21,0,0,0-1.12-4.18c-.12-.2-.3-.32-.42-.52a3.67,3.67,0,0,1-.51-.33,2.64,2.64,0,0,0-2.55-.06,1.71,1.71,0,0,0-.65.28,2.33,2.33,0,0,0-.61.44,8.64,8.64,0,0,0-2.5,3c-.18.32-.32.63-.5.91s-.25.63-.4,1a14.83,14.83,0,0,0-1,5.41,7.07,7.07,0,0,0,1.15,4.11,5,5,0,0,1,.42.52,3,3,0,0,1,.51.34l.92-1.92Zm-.14-9.47h0l1.62,1.48.63.58.66.6.3.28,2.25,2.06a10.15,10.15,0,0,0,.69-3.74,5.17,5.17,0,0,0-.78-2.95,2.09,2.09,0,0,0-.93-.85,1.9,1.9,0,0,0-1.6-.11c-.21.12-.41.15-.65.28s-.41.32-.61.44a6.87,6.87,0,0,0-1.58,1.93h0a6.87,6.87,0,0,1,1.58-1.93c.2-.12.41-.32.61-.44s.44-.16.65-.28a1.9,1.9,0,0,1,1.6.11,2.09,2.09,0,0,1,.93.85,5.17,5.17,0,0,1,.78,2.95,10.15,10.15,0,0,1-.69,3.74l-2.25-2.06-.3-.28-.66-.6-.63-.58-1.62-1.48Z",
    transform: "translate(-1352 -1235)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "95.02 525.16 95.24 540.7 84.94 546.6 84.71 531.06 95.02 525.16"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M1445.45,1774.72h0a9.33,9.33,0,0,1-3.38,3.94l-5.14,2.94,0-2,1.7-1,3.43-2c2.15-1.23,3.81-4.77,3.77-8s-1.79-4.92-3.93-3.69l-3.44,2-1.7,1,0-1.9,5.14-2.94,5.17-3,0,1.9-1.77,1c1.08.9,1.82,2.53,1.85,4.88a14.9,14.9,0,0,1-1.68,6.77h0a14.9,14.9,0,0,0,1.68-6.77c0-2.35-.77-4-1.85-4.88l1.77-1,0-1.9-5.17,3-5.14,2.94,0,1.9,1.7-1,3.44-2c2.14-1.23,3.88.46,3.93,3.69s-1.62,6.73-3.77,8l-3.43,2-1.7,1,0,2,5.14-2.94a9.33,9.33,0,0,0,3.38-3.94Z",
    transform: "translate(-1352 -1235)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "100.41 539.71 100.52 547.41 85.07 556.25 84.96 548.55 100.41 539.71"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "95.31 547.49 95.31 547.49 95.35 550.37 94.03 551.13 93.99 548.25 85.03 553.38 85 551.42 93.96 546.3 93.92 543.42 95.24 542.66 95.28 545.54 100.45 542.59 100.48 544.53 95.31 547.49 95.31 547.49 95.31 547.49 100.48 544.53 100.45 542.59 95.28 545.54 95.24 542.66 93.92 543.42 93.96 546.3 85 551.42 85.03 553.38 93.99 548.25 94.03 551.13 95.35 550.37 95.31 547.49 95.31 547.49"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "157.92 126.77 158.14 142.09 144.82 149.72 144.6 134.39 157.92 126.77"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "158.15 142.29 158.37 157.62 145.05 165.24 144.83 149.91 158.15 142.29"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "158.38 157.82 158.6 173.14 145.28 180.76 145.06 165.44 158.38 157.82"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "144.43 134.5 144.65 149.82 131.33 157.44 131.11 142.12 144.43 134.5"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "144.65 150.02 144.87 165.34 131.56 172.97 131.34 157.65 144.65 150.02"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "144.88 165.55 145.1 180.87 131.78 188.49 131.56 173.16 144.88 165.55"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "130.93 142.23 131.15 157.55 117.83 165.17 117.61 149.85 130.93 142.23"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "131.16 157.75 131.38 173.08 118.06 180.7 117.84 165.37 131.16 157.75"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "131.38 173.28 131.6 188.6 118.28 196.22 118.07 180.9 131.38 173.28"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-73"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "148.81 243.24 149.72 306.56 102.49 333.59 101.58 270.27 148.81 243.24"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M1499.33,1511.28h0q-.19-13.82-7.15-18.12-6.33-3.87-15.2,1.22t-14.79,15.95a51.24,51.24,0,0,0-6.42,25.89,34.56,34.56,0,0,0,1.75,10.59c1.11,3.28,2.35,5.31,3.74,6.07l-1.42,1.94c-1.38-.61-2.67-2.61-3.89-6a36.56,36.56,0,0,1-1.91-11.75,55.29,55.29,0,0,1,7-28q6.51-11.77,15.9-17.15,9.58-5.49,16.44-1.28,7.68,4.71,7.89,19.55a55.83,55.83,0,0,1-3.61,20.35,51.46,51.46,0,0,1-14.41,21.21l-1.88,1.32c-.92.63-1.58,1.06-2,1.29q-5.51,3.17-9.43,2.58c-3.29-.53-5-3-5-7.5a11,11,0,0,1,2.57-7.26,13.58,13.58,0,0,1,4-3.48l.72-.17a7.37,7.37,0,0,1-2.26,0c-3.45-.82-5.21-4.51-5.31-11a21.91,21.91,0,0,1,2.94-11.58,20,20,0,0,1,7.22-7.6q5.24-3,9.39-.79,4.58,2.37,4.69,10a25.69,25.69,0,0,1-2.16,10.41,17.44,17.44,0,0,1-3.17,5.44l4.92-1.69,0,2.32-14.73,6.09q-2.45,1.65-4.78,3.31a6.55,6.55,0,0,0-2.09,5.3q.08,4.93,4.4,5.45a13.49,13.49,0,0,0,8.3-2.1,27.34,27.34,0,0,0,3.26-2.19,51.15,51.15,0,0,0,16.52-38.6h0a51.15,51.15,0,0,1-16.52,38.6,27.34,27.34,0,0,1-3.26,2.19,13.49,13.49,0,0,1-8.3,2.1q-4.32-.51-4.4-5.45a6.55,6.55,0,0,1,2.09-5.3q2.34-1.67,4.78-3.31l14.73-6.09,0-2.32-4.92,1.69a17.44,17.44,0,0,0,3.17-5.44,25.69,25.69,0,0,0,2.16-10.41q-.11-7.66-4.69-10-4.16-2.2-9.39.79a20,20,0,0,0-7.22,7.6,21.91,21.91,0,0,0-2.94,11.58c.1,6.54,1.86,10.23,5.31,11a7.37,7.37,0,0,0,2.26,0l-.72.17a13.58,13.58,0,0,0-4,3.48,11,11,0,0,0-2.57,7.26c.06,4.48,1.75,7,5,7.5q3.93.58,9.43-2.58c.41-.23,1.07-.66,2-1.29l1.88-1.32a51.46,51.46,0,0,0,14.41-21.21,55.83,55.83,0,0,0,3.61-20.35q-.21-14.85-7.89-19.55-6.86-4.21-16.44,1.28-9.39,5.37-15.9,17.15a55.29,55.29,0,0,0-7,28,36.56,36.56,0,0,0,1.91,11.75c1.22,3.41,2.51,5.41,3.89,6l1.42-1.94c-1.39-.76-2.63-2.79-3.74-6.07a34.56,34.56,0,0,1-1.75-10.59,51.24,51.24,0,0,1,6.42-25.89q6-10.93,14.79-15.95t15.2-1.22q7,4.3,7.15,18.12Zm-12.44,7.3h0c-.06-4.18-1.17-7-3.32-8.39-2-1.26-4.37-1.28-7.24-.07l-1.54.88a16.75,16.75,0,0,0-5.86,6,16.14,16.14,0,0,0-2.4,8.79v.56q.1,6.86,3.59,8.77t8-.68a16.85,16.85,0,0,0,6.12-6.17,18,18,0,0,0,2.65-9.7h0a18,18,0,0,1-2.65,9.7,16.85,16.85,0,0,1-6.12,6.17q-4.5,2.6-8,.68t-3.59-8.77v-.56a16.14,16.14,0,0,1,2.4-8.79,16.75,16.75,0,0,1,5.86-6l1.54-.88c2.87-1.21,5.29-1.19,7.24.07,2.15,1.42,3.26,4.21,3.32,8.39Z",
    transform: "translate(-1352 -1235)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 115.55,
    y1: 492.42,
    x2: 116.49,
    y2: 557.39
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilacom);
export default __webpack_public_path__ + "static/media/filacom.0f86088934b4ec7a342bb969912854be.svg";
export { ForwardRef as ReactComponent };